import beautyWellnessBanner from "../assets/niche/beauty-wellness.png";
import fitnessWellnessBanner from "../assets/niche/fitness-wellness.jpeg";
import healthcareBanner from "../assets/niche/healthcare.jpeg";
import hospitalityFoodBanner from "../assets/niche/hospitality-food.jpeg";
import allNicheBanner from "../assets/niche/all-niche.jpeg";
import { NICHE_LANDING_PAGES } from "./nicheLandingPages";

/**
 * Niche-specific hero backgrounds. Niches without an entry use {@link allNicheBanner}.
 * @type {Record<string, string>}
 */
export const NICHE_BANNER_IMAGES = {
    "beauty-wellness": beautyWellnessBanner,
    "fitness-wellness": fitnessWellnessBanner,
    healthcare: healthcareBanner,
    "hospitality-food": hospitalityFoodBanner,
};

/** @param {string | null | undefined} nicheId */
export function getNicheBannerImage(nicheId) {
    if (!nicheId) return null;
    return NICHE_BANNER_IMAGES[nicheId] ?? allNicheBanner;
}

/** All niche landing banners for the guest home carousel (no niche selected). */
export function getNicheBannerCarouselSlides() {
    return NICHE_LANDING_PAGES.map((page) => ({
        id: page.id,
        title: page.header,
        description: page.description,
        backgroundImage: getNicheBannerImage(page.id),
        wizardRef: page.path,
    }));
}
